<script setup lang="ts">
import { useLocalStorage } from "@vueuse/core";
import { watch } from "vue";

import { THEME_LOCAL_STORAGE_KEY, ThemeContext } from "@/components/theme/theme-context.ts";

import { usePrimeVue } from "primevue/config";

const theme = useLocalStorage<"light" | "dark">(THEME_LOCAL_STORAGE_KEY, "light");
const PrimeVue = usePrimeVue();

function setTheme(next: "light" | "dark") {
  theme.value = next;
}

function switchTheme() {
  theme.value = theme.value === "dark" ? "light" : "dark";
}

watch(
  () => theme.value,
  () => {
    if (theme.value === "dark") {
      document.documentElement.classList.add("dark");
      PrimeVue.changeTheme("lara-light-blue", "lara-dark-blue", "theme-link");
    } else {
      document.documentElement.classList.remove("dark");
      PrimeVue.changeTheme("lara-dark-blue", "lara-light-blue", "theme-link");
    }
  },
  { immediate: true },
);
</script>

<template>
  <ThemeContext.Provider :value="{ switchTheme, theme, setTheme }">
    <slot></slot>
  </ThemeContext.Provider>
</template>

<style scoped></style>
